export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13541.deee77f1.jpg";